var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.drawComponent && !_vm.disableCalendar
    ? _c("div", { staticClass: "date-field" }, [
        _c(
          "label",
          {
            staticClass: "date-field__label",
            class: {
              "date-field__label--unfocus": !_vm.value,
              "date-field__label--disabled": _vm.disabled
            }
          },
          [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "date-field__field",
            class: { "date-field__field--disabled": _vm.disabled }
          },
          [
            _c("flat-pickr", {
              ref: "calendar",
              staticClass: "date-field__input",
              attrs: {
                id: _vm.id,
                config: _vm.config,
                value: _vm.value,
                disabled: _vm.disabled
              },
              on: { onOpen: _vm.setConfig, change: _vm.changeValue },
              nativeOn: {
                input: function($event) {
                  return _vm.dateFieldUpdated.apply(null, arguments)
                }
              }
            }),
            _vm._v(" "),
            _vm.clearable && _vm.value && _vm.value.length
              ? _c(
                  "span",
                  {
                    staticClass: "date-field__clear",
                    on: { click: _vm.reset }
                  },
                  [
                    _c("md-icon", { staticClass: "clear-icon" }, [
                      _vm._v("clear")
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.errorMessage
          ? _c("div", { staticClass: "date-field__err-mes" }, [
              _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6411fd40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6411fd40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/fields/DateFieldFlatpickr.vue
// module id = V8r6
// module chunks = 1